import React from 'react';
import Utils from 'utilities/helper.util';
import { TooltipIcon } from 'carbon-components-react';
import { HelpFilled16 } from '@carbon/icons-react';

export const ResponsesList: React.FC<Props | any> = (props: Props) => {
  const { responses, handleResponseSelection, selectedResponse } = props;

  return (
    <div className="get-responses-actions-responses">
      <div className="get-responses-actions-responses-header">
        <div>RESPONSES</div>
        <div className="get-responses-actions-responses-header-tooltip-icon">
          <TooltipIcon
            tooltipText={'Responses and plans you provided'}
            className="tooltip referral-history-tooltip"
          >
            <HelpFilled16 className="tooltip-icon" />
          </TooltipIcon>
        </div>
      </div>
      <div className="get-responses-actions-responses-listing">
        {responses
          ?.sort((a: any, b: any) => a.id - b.id)
          .map((response: any, index: any) => (
            <div
              className={`get-responses-actions-responses-listing-row completed ${
                selectedResponse === index ? 'selected' : ''
              }`}
              key={index}
              onClick={() => handleResponseSelection(index)}
            >
              <div
                className={`get-responses-actions-responses-listing-row-indicator ${
                  selectedResponse === index ? 'indicator-selected' : ''
                }`}
              />
              <div
                className={`get-responses-actions-responses-listing-row-name ${
                  selectedResponse === index ? 'response-selected' : ''
                }`}
              >
                Response {index + 1} <br />
                <div className="get-responses-actions-responses-listing-row-timeStamp">
                  {Utils.toLocalDateTimeFormat(response.created_at)}
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

type ownProps = {
  responses: any;
  handleResponseSelection: any;
  selectedResponse: number;
};

type Props = ownProps;

ResponsesList.displayName = 'ResponsesList';

export default React.memo(ResponsesList);
